import { render, staticRenderFns } from "./DownloadExams.vue?vue&type=template&id=0bf0bac6"
import script from "./DownloadExams.vue?vue&type=script&lang=js"
export * from "./DownloadExams.vue?vue&type=script&lang=js"
import style0 from "./DownloadExams.vue?vue&type=style&index=0&id=0bf0bac6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports